module.exports = __webpack_public_path__ + "img/sand-dune-decal-12.0b276dac.png";